module.exports = __webpack_public_path__ + "static/media/automatedcontent_section2.054c6deb.png";